module.exports = __webpack_public_path__ + "img/mrmattranger-7c3a7299-e017-4ac6-757d-08d957704faf.png";